import { FC, Suspense } from "react";
import { useTranslation } from "react-i18next";
import { useRecoilValue } from "recoil";

import { ConfirmDialogHolder, ErrorBoundary } from "@ryde/controls";
import { useRtl } from "@ryde/redux";
import { Log } from "@ryde/shared";
import {
  apiDataFetchingLandingAtom,
  landingInfoPanelAtom,
  useCompanyScopeLandingsContext,
} from "@ryde/utils-landings";

import {
  LandingInfoPanel,
  LoaderMuiLanding,
  MuiTopProgressLanding,
} from "../widgets";
import { LandingRecaptchaEnterprise, LandingsMapLoader } from "../wrappers";
import { RenderStepsContainerMap } from "./steps-containers";

interface ILandingLayoutProps {
  stepsContainerId?: number;
}

export const LandingLayout: FC<ILandingLayoutProps> = ({
  stepsContainerId,
}) => {
  const { direction } = useRtl();
  const { t } = useTranslation();
  const { companyId } = useCompanyScopeLandingsContext();
  const infoPanel = useRecoilValue(landingInfoPanelAtom);
  const isLandingLoaderShown = useRecoilValue(apiDataFetchingLandingAtom);
  Log.debug(`Landing loaded for company id: ${companyId}`);
  return (
    <ErrorBoundary>
      <Suspense fallback={<MuiTopProgressLanding />}>
        <LandingsMapLoader>
          <LandingRecaptchaEnterprise />
          <RenderStepsContainerMap containerId={stepsContainerId} />
          {infoPanel?.isDisplayed && <LandingInfoPanel infoPanel={infoPanel} />}
        </LandingsMapLoader>
        <div dir={direction} className="modals_container">
          <ConfirmDialogHolder />
        </div>
        {isLandingLoaderShown && (
          <LoaderMuiLanding loading text={t("ui.LOADING_DATA")} />
        )}
      </Suspense>
    </ErrorBoundary>
  );
};
